import styled from 'styled-components';

export const ErrorField = styled.span`
    color: red;
    font-size: 0.75rem;
    margin-top: 0.25rem;
`;

export default ErrorField;